<template>
    <button class="btn btn-primary text-uppercase font-weight-bold px-4 py-2 mr-md-3 mb-4 btn__rounded d-lg-none"
        @click="openFilter">
        Filter
    </button>
</template>

<script>
    export default {
        methods: {
            openFilter() {
                $('body').append(
                    $('<div>')
                        .addClass('modal-backdrop show')
                );

                $('.global__filter').addClass('show');
                $('body').addClass('global__filter--show');
            }
        }
    }
</script>
